import { useRef } from 'react';
import type { CSSProperties, ReactNode } from 'react';
import { DraggableCore } from 'react-draggable';
import type { VariablesGroup } from '../../../../../services/entities/VariablesEntity';
import type { BlockContent } from '../../../grid/reduxStore/editorSlice';
import { Resizable } from 're-resizable';

type PreviewBlockProps = {
  variables?: VariablesGroup;
  gridBlock: BlockContent;
  children?: ReactNode;
  gridSystemInPx: number;
  gridRef?: React.MutableRefObject<HTMLDivElement | null>;
};
export const PreviewBlock = ({ gridBlock: block, children, gridSystemInPx }: PreviewBlockProps) => {
  const nodeRef = useRef<HTMLElement | null>(null);
  const customStyle: CSSProperties = {
    position: 'absolute',
    top: 0,
    left: 0,
    transform: `translate(${block.blockConfig.x}px, ${block.blockConfig.y}px)`,
  };
  const isMac = navigator.userAgent.includes('Mac');
  return (
    <div style={{ zIndex: block.blockConfig.z, position: 'relative' }}>
      <DraggableCore nodeRef={nodeRef} scale={1} grid={[gridSystemInPx, gridSystemInPx]} disabled={true}>
        <Resizable
          ref={(instance) => {
            // Only set on mount, never null out on unmount: DraggableCore's own unmount cleanup
            // needs a valid nodeRef to remove its global drag listeners, and children unmount
            // before parents, so nulling here would race ahead of that cleanup.
            if (instance) {
              nodeRef.current = instance.resizable ?? null;
            }
          }}
          className={`editor__page__draggable ${isMac ? 'is_mac' : ''}`}
          size={{
            width: block.blockConfig.width,
            height: block.blockConfig.height,
          }}
          scale={1}
          boundsByDirection={true}
          minWidth={gridSystemInPx}
          style={customStyle}
          minHeight={gridSystemInPx}
          grid={[gridSystemInPx, gridSystemInPx]}
          enable={false}
        >
          {children}
        </Resizable>
      </DraggableCore>
    </div>
  );
};
